export default __webpack_public_path__ + "img/about-photo-ef053caa.jpg";